import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
const Sidebar = () => {
  const location = useLocation();
  const menuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: '🏠' },
    { path: '/profile', label: 'Profile', icon: '👤' },
    { path: '/contacts', label: 'Contacts', icon: '📞' },
    { path: '/payment-accounts', label: 'Payment Accounts', icon: '💳' },
    { path: '/gateways', label: 'Gateways', icon: '🌐' },
    { path: '/statistics', label: 'Statistics', icon: '📊' },
    { path: '/billing', label: 'Billing', icon: '💰' },
    { path: '/tickets', label: 'Tickets', icon: '🎫' }
  ];
  return (
    <div className="bg-light border-end" style={{ minHeight: '100vh', width: '250px' }}>
      <div className="p-3">
        <h5>Menu</h5>
        <Nav className="flex-column">
          {menuItems.map((item) => (
            <Nav.Link key={item.path} as={Link} to={item.path} active={location.pathname === item.path} className="d-flex align-items-center">
              <span className="me-2">{item.icon}</span>
              {item.label}
            </Nav.Link>
          ))}
        </Nav>
      </div>
    </div>
  );
};
export default Sidebar;
